// extracted by mini-css-extract-plugin
export var active = "_fc-7";
export var blink = "_fc-8";
export var dropDownSelector = "_fc-4";
export var dropDownWrapper = "_fc-3";
export var fakeCursor = "_fc-6";
export var fontSizeButton = "_fc-9";
export var formQuillEditor = "_fc-0";
export var pressed = "_fc-a";
export var qlBlank = "_fc-1";
export var textFormattingToolbar = "_fc-2";
export var textToolbarOption = "_fc-5";